import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import Head from '../components/Head';
import messages from '../lib/messages.mjs';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import HomeLink from '../components/HomeLink';
import Markdown from '../components/Markdown';
import markdown from '../data/staticPages/landing/fashion-internships.md';
import throw404 from '../lib/throw404';
import { useSiteContext } from '../components/SiteContext';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/N_xgmrPAAc6mxrBN0hPjM18BVsZ6xaaCbb_0OWGnrm4/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/cNhZjdHLGLfH9S7gUbLyWLJtg8Np8e0hca60qY9tp38/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/dH_4fbrN9NkpldvGGyYSzB1E7THYL_-CpfNkIBGKq5k/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/vyiGz6ebEf-4gGJ-Yt-scHGfE_FYcIeZDsJJawhiEjY/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/tB3FxJElzRyc8Squh1mHJesLFcqzeySSUC9OmtDAKv4/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/3_Gk08pjRntXJPcgsN7ouyWxOXuaiWoBhhm-a4rc_YM/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/a-1LxF2s0ej6fzNe2jVLZbvIWvGqyHraSdp-f2opG4k/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9pbnRlcm5zaGlwc19iYW5uZXJfZGVza3RvcC5qcGc',
  ],
};

const FashionInternshipsPage = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();

  const breadcrumbs = [
    <HomeLink />,
    intl.formatMessage(messages['fashion-internships.title']),
  ];

  if (locale !== 'en-US') return throw404();

  return (
    <>
      <Head
        title={intl.formatMessage(messages['fashion-internships.title'])}
        description={intl.formatMessage(
          messages['fashion-internships.description'],
        )}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={(
          <Markdown
            markdown={markdown}
            allowHtml
            allowGfm
          />
        )}
        title={intl.formatMessage(messages['fashion-internships.title'])}
      />
    </>
  );
};

FashionInternshipsPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Fashion Internships"
        imageUrls={headerImageUrls}
      />
    )}
  >
    {page}
  </Layout>
);

export default FashionInternshipsPage;
